import angular from 'angular';
import _ from 'lodash';
import ModelUpdateNotAllowedModal from '../modals/model-update-not-allowed.data';

class invoiceParamCtrl {
    /* @ngInject */
    constructor(
        $location,
        $state,
        $scope,
        logger,
        $uibModal,
        $translate,
        CONF,
        INVOICE_PARAM,
        InvoiceParamSvc,
        AuthSvc,
        DocumentModelDA,
        InvoiceTemplateDA
    ) {
        this.$location = $location;
        this.$state = $state;
        this.$scope = $scope;
        this.logger = logger;
        this.$uibModal = $uibModal;
        this.$translate = $translate;
        this.CONF = CONF;
        this.INVOICE_PARAM = INVOICE_PARAM;
        this.InvoiceParamSvc = InvoiceParamSvc;
        this.AuthSvc = AuthSvc;
        this.DocumentModelDA = DocumentModelDA;
        this.InvoiceTemplateDA = InvoiceTemplateDA;
        this.modelSearch = [];
        this.modelSearch_FactureX = [];
        this.modelSearch_eligibility_enrichment = [];

    }

    $onInit() {
        //----------------------------
        // Variables API
        //----------------------------
        // See _initData
        this.attributes = angular.copy(this.attributes);
        this.sections = this.INVOICE_PARAM.sections;
        this.controlSets = this.buildControlSets(this.controlSets);
        this.rawControlSets = angular.copy(this.controlSets);
        this.defaultBusinessModel = "STANDARD_INVOICE";
        this.defaultFactureX_BC = "STANDARD_INVOICE";
        this.dictionaryKeys = null;
        this.authorizedControlSets = [];
        this.authorizedControlSetsToSelect = [];

        //------------------
        // Sets de controle
        //------------------
        this.unselectStdControlSetMsg = null;

        this._initData(angular.copy(this.invoiceTemplateInfo));
        this.selectedControlSet = this.principal.detail.controlSetReform;
    }

    _initData(invoiceTemplateInfo) {
        // Checkbox permettant de filtrer par type
        this.filters = {lad: true, saisie: true};
        // Template de la facture
        this.invoiceTemplateInfoCopied = angular.copy(invoiceTemplateInfo);
        // indiquer pour chaque attribut sa présence ou non dans le modèle et IHM
        this.fixPresence(this.invoiceTemplateInfoCopied);
        // On sépare les différentes catégories
        this.invoiceAttributes = this._copyAttributeByCat(this.invoiceTemplateInfoCopied);
        /* Récuperation des modèles et set de comtrôles des factures */
        this.getParamsReform();
        /* Récuperation des modèles du factures X */
        this.getParamsFacturX();
        /* Récuperation les control-sets (set d’enrichissement spécifique sur l'éligibilité) */
        this.getParamsEligibilityEnrichmentSet()
    }

    _copyAttributeByCat(invoiceTemplateInfo) {
        return {
            seller: invoiceTemplateInfo.getAttBySection('seller'),
            buyer: invoiceTemplateInfo.getAttBySection('buyer'),
            header: invoiceTemplateInfo.getAttBySection('header'),
            currency: invoiceTemplateInfo.getAttBySection('currency'),
            line: invoiceTemplateInfo.getAttBySection('line'),
            reduction: invoiceTemplateInfo.getAttBySection('reduction'),
            cost: invoiceTemplateInfo.getAttBySection('cost'),
            total: invoiceTemplateInfo.getAttBySection('total'),
            tax: invoiceTemplateInfo.getAttBySection('tax'),
            payment: invoiceTemplateInfo.getAttBySection('payment'),
            footer: invoiceTemplateInfo.getAttBySection('footer'),
            technical: invoiceTemplateInfo.getAttBySection('technical'),
        };
    }

    getParamsReform() {
        var specificParams = this.DocumentModelDA.getModelByCategoryAndTypeAndParentKey(this.principal.detail.eid, 'MODEL', 'INVOICE', "STANDARD_INVOICE").then(data => {
            this.modelSearch = _.union(this.modelSearch, data);
            //  Le contenu de la liste est trié par ordre alphabétique.
            this.modelSearch.sort((a, b) => a.localeCompare(b));
            // Séléction du business model et par défaut afficher 'STANDARD_INVOICE'
            this.selectedBusinessModel = this.getSelectedBusinessModel();
            this.dictionaryKeys = this.modelSearch;
            this.getSpecificSets(this.principal.detail.eid, this.dictionaryKeys);

        });
        return specificParams;
    }

    // Récupération du BusinessModel sélectionné
    getSelectedBusinessModel() {
        return this.modelSearch.find(element => element === this.principal.detail.businessModelReform) || this.defaultBusinessModel;
    }

    // Récupération des sets de contrôles du business model sélectionné
    getSpecificSets(eid, dictionaryKeys) {
        this.InvoiceTemplateDA.getPrincipalControlSets(eid, dictionaryKeys).then(data => {
            this.authorizedControlSets = data.filter(e => e.standard === false);
            this.authorizedControlSetsToSelect = data.filter(e => e.dictionaryKey === this.selectedBusinessModel && e.standard === false);
            this.onChangedBusinessModel(false);
        });
    }

    onChangedBusinessModel(isChanged) {
        if (isChanged)
            this.selectedControlSet = null;
        var matchesSelectedBusinessModel = this.authorizedControlSets.filter(e => e.dictionaryKey === this.selectedBusinessModel);
        var matchesStandardInvoice = this.authorizedControlSets.filter(e => e.dictionaryKey === this.defaultBusinessModel && e.filtreDO === true);
        if (this.selectedBusinessModel !== this.defaultBusinessModel)
            this.authorizedControlSetsToSelect = matchesSelectedBusinessModel.concat(matchesStandardInvoice);
        else
            this.authorizedControlSetsToSelect = matchesStandardInvoice;
    }

    getParamsFacturX() {
        var specificEdi = this.DocumentModelDA.getModelByCategoryAndTypeAndParentKey(this.principal.detail.eid, 'MODEL', 'INVOICE', "STANDARD_INVOICE").then(data => {
            this.modelSearch_FactureX = _.union(this.modelSearch_FactureX, data);
            //  Le contenu de la liste est trié par ordre alphabétique.
            this.modelSearch_FactureX.sort((a, b) => a.localeCompare(b));
            // Par défaut, le modèle STANDARD_INVOICE est sélectionné.
            this.selectedBusinessModel_FactureX = this.modelSearch_FactureX.find(element => element === this.principal.detail.businessModelFactureX) || this.defaultFactureX_BC;
        });

        return specificEdi;
    }

    getParamsEligibilityEnrichmentSet() {
        var specificEdi = this.DocumentModelDA.getControlSetByClientKeyAndType(this.principal.detail.eid, "E_REPORTING_ENRICH").then(data => {
            this.modelSearch_eligibility_enrichment = _.union(this.modelSearch_eligibility_enrichment, data);
            //  Le contenu de la liste est trié par ordre alphabétique.
            this.modelSearch_eligibility_enrichment.sort((a, b) => a.localeCompare(b));
            // Par défaut, "Sélectionner un set spécifique" est sélectionné.
            this.selectedEligibilityEnrichmentSet = this.modelSearch_eligibility_enrichment.find(element => element === this.principal.detail.eligibilityEnrichmentSet);
        });

        return specificEdi;
    }

    buildControlSets(controlSets) {
        var ladControlSets = _.filter(controlSets, controlSet => {
            return controlSet.mode === 'lad';
        });
        var saisieControlSets = _.filter(controlSets, controlSet => {
            return controlSet.mode === 'saisie' && !controlSet.submode;
        });
        var saisiePoFlipControlSets = _.filter(controlSets, controlSet => {
            return controlSet.mode === 'saisie' && controlSet.submode === 'POFLIP';
        });
        return {
            ladControlSets: ladControlSets,
            saisieControlSets: saisieControlSets,
            saisiePoFlipControlSets: saisiePoFlipControlSets,
        };
    }

    //----------------------------
    // Gestion des champs de la facture
    //----------------------------
    addItem(addedAttributes, section) {
        this.InvoiceParamSvc.addAttributesToSection(this.invoiceAttributes[section], addedAttributes);
    }

    removeItem(attribute) {
        _.remove(this.invoiceTemplateInfoCopied.invoiceTemplate.attributes, a => {
            return a.path === attribute.path && a.section === attribute.section;
        });
    }

    displayDetail() {
        return this.invoiceTemplateInfoCopied.specificTemplate === true;
    }

    //------------------------------
    // Gestion des sets de controle
    //------------------------------
    onControlSetChange(set, ladSaisie) {
        //vérifier qu'il reste au moins un control set sélectionné
        if (!set.selected) {
            var controlSets = null;
            switch (ladSaisie) {
                case 'lad':
                    controlSets = this.controlSets.ladControlSets;
                    break;
                case 'saisie':
                    controlSets = this.controlSets.saisieControlSets;
                    break;
                case 'saisie-poflip':
                    controlSets = this.controlSets.saisiePoFlipControlSets;
                    break;
                default:
                    break;
            }
            var length = _.filter(controlSets, {selected: true}).length;
            if (length == 0) {
                set.selected = true;
                return;
            }
        }

        if (set.standard && !set.selected) {
            this.unselectStdControlSetMsg = this.$translate.instant(
                'principal.invoice_param.modal_control_set.' + ladSaisie + '_text'
            );
            this.$uibModal
                .open({
                    scope: this.$scope,
                    templateUrl: require('../modals/modal-unselect-standard-controlset.html'),
                    size: 'md',
                })
                .result.then(
                () => {
                    set.selected = true;
                },
                () => {
                }
            );
        }
    }

    // Navigation
    //----------------------------
    back() {
        this.$state.go('do', {tabName: 'principal'});
    }

    cancel() {
        this.controlSets = angular.copy(this.rawControlSets);
        this._initData(angular.copy(this.invoiceTemplateInfo));
    }

    update() {
        if (
            !this.InvoiceParamSvc.findDoublons(
                this.invoiceTemplateInfoCopied.invoiceTemplate.attributes,
                'mappingLadAuto',
                'zedocDoublon'
            )
        ) {
            this.saveModelPromise = this.InvoiceParamSvc.saveInvoiceTemplate(
                this.principal.detail.eid,
                this.invoiceTemplateInfoCopied,
                this.invoiceAttributes,
                this.controlSets,
                this.legibleFile,
                this.selectedBusinessModel,
                this.selectedControlSet,
                this.selectedBusinessModel_FactureX,
                this.selectedEligibilityEnrichmentSet
            );
            this.saveModelPromise.then(
                data => {
                    if (data.result.length > 0) {
                        new ModelUpdateNotAllowedModal(this.$uibModal, () =>
                            this.cancel()
                        ).openModelUpdateNotAllowedModal(data.result);
                    } else {
                        this.logger.success('success.update', null, null, {entityName: 'Le template de facture'});
                        this.rawControlSets = angular.copy(this.controlSets);
                        // si un nouveau legible a été chargé, maj le lien pour afficher le legible
                        if (this.legibleFile) {
                            this.legibleFileId = data.legibleFileId;
                        }
                        //reset du fichier
                        this.legibleFile = null;
                    }
                },
                error => {
                    if (error.status === 400 && error.data && error.data.code === 'INVALID_LEGIBLE_TEMPLATE') {
                        this.logger.error('error.functional.' + angular.lowercase(error.data.code), error);
                    } else {
                        this.logger.error('error.update', error);
                    }
                }
            );
        } else {
            this.$location.hash('page-top');
            this._initData(this.invoiceTemplateInfoCopied);
        }
    }

    fixPresence(invoiceTemplateInfo) {
        angular.forEach(invoiceTemplateInfo.invoiceTemplate.attributes, attribute => {
            angular.forEach(this.INVOICE_PARAM.presenceOptions, option => {
                if (option.model === attribute.lad && option.visible === attribute.visibleLad)
                    attribute.presenceLad = option;
                if (option.model === attribute.saisie && option.visible === attribute.visibleSaisie)
                    attribute.presenceSaisie = option;
            });
        });
    }

    getLegibleLink() {
        return this.CONF.apiContext + this.CONF.apiBaseUrl + '/v1/files/' + this.legibleFileId;
    }

    isEditAuthorized() {
        return this.AuthSvc.isEditAuthorized();
    }
}

angular.module('app.principal').component('invoiceParam', {
    templateUrl: require('./invoice-param.html'),
    controller: invoiceParamCtrl,
    bindings: {
        invoiceTemplateInfo: '<',
        attributes: '<',
        principal: '<',
        controlSets: '<',
        legibleFileId: '<',
    },
});
